import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import { loadAgentFile } from "@ext/agent/components/message/loadAgentFile";
import { LinkAdapter } from "@ext/agent/mcp/parser/adapters/linkAdapter";
import { type ImgHTMLAttributes, useEffect, useState } from "react";

const useAgentFileUrl = (href: string) => {
	const apiUrlCreator = ApiUrlCreatorService.value;
	const [url, setUrl] = useState<string | null>(null);

	useEffect(() => {
		const controller = new AbortController();
		let objectUrl: string | null = null;
		setUrl(null);

		void loadAgentFile(href, apiUrlCreator, controller.signal).then((file) => {
			if (!file || controller.signal.aborted) return;
			objectUrl = URL.createObjectURL(new Blob([file.buffer]));
			setUrl(objectUrl);
		});

		return () => {
			controller.abort();
			if (objectUrl) URL.revokeObjectURL(objectUrl);
		};
	}, [href]);

	return url;
};

const AgentChatFileImage = ({ src, ...rest }: ImgHTMLAttributes<HTMLImageElement> & { src: string }) => {
	const url = useAgentFileUrl(src);
	if (!url) return <span className="inline-block h-32 w-48 max-w-full rounded-md bg-secondary-bg" />;
	return <img {...rest} src={url} />;
};

export const AgentChatImage = ({ src, ...rest }: ImgHTMLAttributes<HTMLImageElement>) => {
	if (src && LinkAdapter.fromAgentFileHref(src)) return <AgentChatFileImage {...rest} src={src} />;
	return <img {...rest} src={src} />;
};
